import React, { useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { projectTypes } from "../../mock";
import { inputCls } from "./Contact";
import { submitQuote, errMsg } from "../../lib/api";

export default function QuoteModal({ open, onOpenChange }) {
  const empty = { name: "", email: "", phone: "", projectType: "", details: "" };
  const [f, setF] = useState(empty);
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.name || !f.email) return toast.error("Name and email are required.");
    setSending(true);
    try {
      await submitQuote(f);
      setF(empty);
      onOpenChange(false);
      toast.success("Quote request received! We usually respond within 24 hours.");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg bg-zinc-950 border-white/10 text-white rounded-3xl p-8" data-testid="quote-modal">
        <DialogTitle className="font-display text-3xl font-bold">Request a Quote</DialogTitle>
        <DialogDescription className="text-white/55">Share a few details and our team will follow up.</DialogDescription>
        <form onSubmit={submit} className="space-y-5 mt-2">
          <input placeholder="Full name" data-testid="quote-name" className={inputCls} value={f.name} onChange={set("name")} />
          <input placeholder="Email address" type="email" data-testid="quote-email" className={inputCls} value={f.email} onChange={set("email")} />
          <input placeholder="Phone (optional)" data-testid="quote-phone" className={inputCls} value={f.phone} onChange={set("phone")} />
          <Select value={f.projectType} onValueChange={(v) => setF({ ...f, projectType: v })}>
            <SelectTrigger data-testid="quote-project-type" className="bg-transparent border-0 border-b border-white/20 rounded-none px-0 text-white focus:ring-0 h-12">
              <SelectValue placeholder="Project type" />
            </SelectTrigger>
            <SelectContent className="bg-zinc-900 border-white/10 text-white z-[100]">
              {projectTypes.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
            </SelectContent>
          </Select>
          <textarea placeholder="Project details" rows={3} data-testid="quote-details" className={`${inputCls} resize-none`} value={f.details} onChange={set("details")} />
          <button disabled={sending} data-testid="quote-submit" className="w-full flex items-center justify-center gap-2 bg-yellow-400 text-black font-bold tracking-[0.12em] py-4 rounded-2xl hover:bg-yellow-300 disabled:opacity-60 transition-colors">
            {sending ? "SUBMITTING..." : <>SUBMIT REQUEST <Send className="w-4 h-4" /></>}
          </button>
          <p className="text-center text-white/40 text-xs">We usually respond within 24 hours</p>
        </form>
      </DialogContent>
    </Dialog>
  );
}
